import { Card, CardContent } from '@/components/ui/Card.tsx';
import timeUtils from '@/utils/timeUtils.ts';
import TextInfoSection from '@/features/public/booking/components/TextInfoSection.tsx';
import { BookingTourBasicDataDto } from '@/features/public/booking/types/BookingTourBasicDataDto.ts';

type BookingTourCancelledContentProps = {
  tourBasicInfo: BookingTourBasicDataDto;
};

/**
 * Wyjazd odwołany — zapisów nie będzie i nie ma po co proponować listy
 * rezerwowej (backend i tak jej nie przyjmie).
 */
const BookingTourCancelledContent = ({
  tourBasicInfo,
}: BookingTourCancelledContentProps) => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-base-text">
          Wyjazd <b>{tourBasicInfo.tourName}</b> został odwołany.
        </h1>

        <p className="text-neutral-500">
          Zapisy na ten wyjazd nie są prowadzone. Skontaktuj się z
          organizatorem, aby dowiedzieć się o innych dostępnych terminach.
        </p>
      </div>

      <Card>
        <CardContent className="space-y-6">
          <TextInfoSection
            title="Planowany termin wyjazdu"
            info={
              <>
                <p>
                  Rozpoczęcie:{' '}
                  <span className="font-semibold">
                    {timeUtils.toDateString(tourBasicInfo.startDate)}
                  </span>
                </p>
                <p>
                  Zakończenie:{' '}
                  <span className="font-semibold">
                    {timeUtils.toDateString(tourBasicInfo.endDate)}
                  </span>
                </p>
              </>
            }
          />

          {tourBasicInfo.tourDescription &&
            tourBasicInfo.tourDescription.length > 0 && (
              <TextInfoSection
                title="Opis wyjazdu"
                info={tourBasicInfo.tourDescription}
              />
            )}
        </CardContent>
      </Card>
    </div>
  );
};

export default BookingTourCancelledContent;
